import { Toast } from "primereact/toast";
import React, { useContext, useEffect, useRef, useState } from "react";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";

import { useForm } from "../../../Base/Hooks/useForm";
import Loader from "../../../Base/Components/Loader/Loader";
import { toastShow } from "../../../Base/Services/ToastService";
import { getDateTimeStringSQL } from "../../../Base/Services/Moment/Luxon";
import { AuthContext } from "../../../Base/Context/AuthContext/AuthContext";

import { getAreas } from "../../../API/Global/Areas/AreasRequests";
import { getWarehouses } from "../../../API/Compras/Otros/WareHouses";
import {
  getTerminos,
  getTerminosPago,
} from "../../../API/Compras/Otros/TerminosRequests";
import { getCurrency } from "../../../API/Global/Currency/CurrencyRequests";
import { getAgentesCompras } from "../../../API/Global/Agentes/AgentesRequests";
import { getEstadosPurchase } from "../../../API/Global/Status/StatusRequests";
import { getTipoPurchase } from "../../../API/Compras/Otros/TipoCompraRequests";
import {
  getCustomers,
  getCustomersDetail,
} from "../../../API/Clientes/ClientesRequests";
import { getProveedoresActivos } from "../../../API/Compras/Proveedores/ProveedoresRequests";
import {
  obtenerDetalleOrdenCompra,
  obtenerOrdenCompra,
  obtenerNumeroOrden,
  GuardarOrden,
  EditarOrden,
  cambiarEstadoOrdenDetalle,
} from "../../../API/Compras/Ordenes/OrdenesComprasRequests";

import ItemOverlayPanel from "./ItemOverlayPanel";

import EncabezadoOrdenesCompras from "./EncabezadoOrdenesCompras";
import { permisosByUsuario } from "../../../API/IT/Accesos/AccesosRequests";
import AgGrid from "../../../Base/Components/Tables/AgGrid/AgGrid";
import { getPurchaseRequestDetailAuth } from "../../../API/Compras/Requisas/PurchareDetailsRequests";

const OrdenesComprasCrud = ({
  PurchaseOrder = undefined,
  habilitar,
  setHabilitar = () => { },
}) => {
  
  const dtAutorizarRequisa = useRef();
  const overlayItemRef = useRef();

  const { userAuth } = useContext(AuthContext);

  let contador = 3;

  const toast = useRef();

  const [loading, setLoading] = useState(false);
  const [selected, setSelected] = useState([]);
  const [clienteDetalles, setClienteDetalles] = useState([]);
  const [detalleOrdenCompra, setDetalleOrdenCompra] = useState([]);
  const [inputValues, setinputValues] = useState({});
  const [accesoColumnas, setAccesoColumnas] = useState(false);
  const [numeroOrden, setNumeroOrden] = useState("");

  const initialValues = {
    IdPurchaseOrder: -1,
    NumeroOrden: numeroOrden,
    Date: new Date(),
    Estado: {
      AreaStatus: null,
      IdStatus: 15,
      StatusCategory: "Purchase",
      StatusDescription: null,
      StatusName: "Active",
    },
    RequiredDate: new Date(),
    RequiredDateH: new Date(),
    SubTotal: 0,
    Descuento: 0,
    ISV: 0,
    Freights: 0,
    Otros: 0,
    Total: 0,
    OC: "",
    Comment: "",
    // ClienteDetalle: { Address: '' },
  };

  const { values, handleInputChange, setValues, setNumber } =
    useForm(initialValues);

  const resetForm = () => {
    setValues(initialValues);
    setClienteDetalles([]);
    setSelected([]);
    setHabilitar(true);
  };

  const obtenerInfoInput = async (nueva = false) => {
    setLoading(true);
    const proveedores = await getProveedoresActivos();
    const agentesCompras = await getAgentesCompras();
    const areas = await getAreas();
    const monedas = await getCurrency();
    const customers = await getCustomers();
    const terminos = await getTerminos();
    const terminosPago = await getTerminosPago();
    const estados = await getEstadosPurchase();
    const tipos = await getTipoPurchase();
    const warehouses = await getWarehouses();
    const customersDetaill = await getCustomersDetail(1)

    const val = {
      AgentesCompras: agentesCompras,
      Areas: areas,
      Monedas: monedas,
      Estados: estados,
      Terminos: terminos,
      TerminosPago: terminosPago,
      TipoCompras: tipos,
      Warehouses: warehouses,
      Proveedores: proveedores,
      Clientes: customers,
    };
    setinputValues(val);

    if (PurchaseOrder && !nueva) {
      handleInputChange({
        target: { name: "PurchaseOrder", value: PurchaseOrder },
      });
      getInfo(PurchaseOrder, val);
    } else {
      setDetalleOrdenCompra([]);
      const numOrden = await obtenerNumeroOrden();
      setNumeroOrden(numOrden[0]?.PurchaseOrder || '');
      if (numOrden.length > 0) {
        const cliente = customers.filter((cust) => cust.IdCustomer === 1) || [];
        const agente = agentesCompras.find((a) => a.IdUser === userAuth.idUser) || null;

        const clienteDet = customersDetaill.filter((cd) => cd.IdDCustomer === 11)

        setValues({
          ...initialValues,
          NumeroOrden: numOrden[0]?.PurchaseOrder || '',
          Cliente: cliente[0] || null,
          Agente: agente || null,
          RequiredDate: new Date(),
          RequiredDateH: new Date(),
          Date: new Date(),
          Estado: {
            AreaStatus: null,
            IdStatus: 15,
            StatusCategory: "Purchase",
            StatusDescription: null,
            StatusName: "Active",
          },
          ClienteDetalle: clienteDet[0],
        });
        setHabilitar(true);
      }
    }
    setLoading(false);
  };

  const getInfo = async (id, val = inputValues) => {
    setLoading(true);
    const tempo = await permisosByUsuario(userAuth.idUser);
    setAccesoColumnas(tempo);
    let PO = id === PurchaseOrder ? PurchaseOrder : values.NumeroOrden;
    const infoPurchaseOrder = await obtenerOrdenCompra(PO);
    if (infoPurchaseOrder.length === 0) {
      toastShow(
        toast,
        "warn",
        "ORDEN NO ENCONTRADA",
        "La orden de compra que que desea buscar no existe."
      );
      setLoading(false);
      setSelected([]);
      setDetalleOrdenCompra([]);
      resetForm();
      obtenerInfoInput(true)
    } else {
      asignarValores(infoPurchaseOrder[0], val);
      setHabilitar(false);
      setSelected([]);
    }
    setLoading(false);
  };

  const getDetalleCliente = async (IdCustomer) => {
    const tempo = await getCustomersDetail(IdCustomer);
    return tempo;
  };

  const asignarValores = async (encabezadoOC, inputValues) => {
    setLoading(true);
    // const inputValues = await obtenerInfoInput();
    // console.log({ inputValues });
    let proveTempo = inputValues.Proveedores.filter(
      (item) => item.IdCustomer === encabezadoOC.IdVendor
    );
    let clienteTempo = inputValues.Clientes.filter(
      (item) => item.IdCustomer === encabezadoOC.IdCustomer
    );
    let agenteTempo = inputValues.AgentesCompras.filter(
      (item) => item.IdAgent === encabezadoOC.IdPurchasePerson
    );
    let areaTempo = inputValues.Areas.filter(
      (item) => item.IdArea === encabezadoOC.IdArea
    );
    let estadoTempo = inputValues.Estados.filter(
      (item) => item.IdStatus === encabezadoOC.IdStatus
    );
    let monedaTempo = inputValues.Monedas.filter(
      (item) => item.IdCurrency === encabezadoOC.IdCurrency
    );
    let terminoTempo = inputValues.Terminos.filter(
      (item) => item.IdTerm === encabezadoOC.IdTerms
    );
    let terminoTempoPago = inputValues.TerminosPago.filter(
      (item) => item.IdTerm === encabezadoOC.IdPaymentTerms
    );
    let tipoCompraTempo = inputValues.TipoCompras.filter(
      (item) => item.IdPurchaseType === encabezadoOC.IdPurchaseType
    );
    let warehouseTempo = inputValues.Warehouses.filter(
      (item) => item.IdWarehouse === encabezadoOC.IdWarehouse
    );

    let detallesCliente = await getDetalleCliente(clienteTempo[0].IdCustomer);
    let clienteDetalleTempo = detallesCliente.filter(
      (item) => item.IdDCustomer === encabezadoOC.IdShipto
    );
    const values = {
      IdPurchaseOrder: encabezadoOC.IdPurchaseOrder,
      NumeroOrden: encabezadoOC.PurchaseOrder,
      Proveedor: proveTempo[0],
      Cliente: clienteTempo[0],
      Agente: agenteTempo[0],
      Date: new Date(encabezadoOC.OrderDate),
      Terminos: terminoTempo[0],
      Estado: estadoTempo[0],
      TipoCompra: tipoCompraTempo[0],
      Area: areaTempo[0],
      Bodega: warehouseTempo[0],
      Moneda: monedaTempo[0],
      Entregar: null,
      Comment: encabezadoOC.Description,
      SubTotal: encabezadoOC.SubTotal,
      Descuento: encabezadoOC.Discount,
      ISV: encabezadoOC.ISV,
      Freights: encabezadoOC.Freights,
      Otros: encabezadoOC.Otros,
      Total: encabezadoOC.Total,
      ClienteDetalle: clienteDetalleTempo[0],
      Pro: encabezadoOC.Pro,
      TipoDescuento: null,
      RequiredDate: new Date(encabezadoOC.FechaDesde),
      RequiredDateH: new Date(encabezadoOC.FechaHasta),
      OC: encabezadoOC.OC,
      TerminosPago: terminoTempoPago[0]
    };
    setValues(values);
    getDetalleCompra(encabezadoOC.IdPurchaseOrder);
  };

  const getDetalleCompra = async (IdPurchaseOrder) => {
    const detalles = await obtenerDetalleOrdenCompra(IdPurchaseOrder);
    setDetalleOrdenCompra(detalles);
    setLoading(false);
  };

  // VERIFICA LOS CAMPOS DEL ENCABEZADO PARA SI SON VALIDOS AGREGA UNA NUEVA FILA AL DETALLE
  const verificarCamposEncabezado = () => {
    let error = false;
    switch (true) {
      case values.Proveedor === null || values.Proveedor === undefined:
        toastShow(toast, "warn", "Error", "Seleccione un proveedor.");
        error = true;
        break;
      case values.Cliente === null || values.Cliente === undefined:
        toastShow(toast, "warn", "Error", "Seleccione un cliente.");
        error = true;
        break;
      case values.Agente === null || values.Agente === undefined:
        toastShow(toast, "warn", "Error", "Seleccione un Agente.");
        error = true;
        break;
      case values.Terminos === null || values.Terminos === undefined:
        toastShow(toast, "warn", "Error", "Seleccione un termino de compras.");
        error = true;
        break;
      case values.TerminosPago === null || values.TerminosPago === undefined:
        toastShow(toast, "warn", "Error", "Seleccione un termino de pago.");
        error = true;
        break;
      case values.TipoCompra === null || values.TipoCompra === undefined:
        toastShow(toast, "warn", "Error", "Seleccione el tipo de compra.");
        error = true;
        break;
      case values.Area === null || values.Area === undefined:
        toastShow(toast, "warn", "Error", "Seleccione un area.");
        error = true;
        break;
      case values.Bodega === null || values.Bodega === undefined:
        toastShow(toast, "warn", "Error", "Seleccione una bodega.");
        error = true;
        break;
      case values.Moneda === null || values.Moneda === undefined:
        toastShow(toast, "warn", "Error", "Seleccione una moneda.");
        error = true;
        break;
      case values.ClienteDetalle?.Address === "":
        toastShow(toast, "warn", "Error", "Seleccione una entrega.");
        error = true;
        break;
      default:
        error = false;
        break;
    }
    return error;
  };

  const resetTable = () => {
    let Subtotal = 0;
    let descuento = 0;
    let total = 0;
    let ISV = 0;
    detalleOrdenCompra.forEach((detalle) => {
      Subtotal += detalle.QtyOrdered * detalle.UnitPrice;
      descuento += detalle.Descuento;
      ISV += detalle.ISV;
      total +=
        detalle.QtyOrdered * detalle.UnitPrice +
        detalle.ISV -
        detalle.Descuento;
    });
    // dtAutorizarRequisa.current.reset();

    setValues({
      ...values,
      SubTotal: Subtotal,
      Descuento: descuento,
      Total: total,
      ISV: ISV,
    });
    return true;
  };

  const addRequisas = (infoRequisas) => {
    let RequisasExistente = detalleOrdenCompra.some((i) =>
      infoRequisas.some((f) => f.IdProduct === i.IdComponent)
    );

    if (RequisasExistente) {
      toastShow(toast, "warn", "Advertencia", "No se permiten valores repetidos");
    } else {
      let dataNueva = [];
      infoRequisas.forEach((f) => {
        let Id = (detalleOrdenCompra.length + dataNueva.length + 1) * -1;
        dataNueva.push({
          IdPurchaseOrderDetail: Id,
          FechaCreado: new Date(),
          PurchaseRequest: f.PurchaseRequest,
          IdRequest: f.IdPurcharesRequestDetail,
          IdStatus: 3333,
          Estado: "En OC",
          IdComponent: f.IdProduct,
          CodigoProducto: f.CodigoProducto,
          NombreProducto: f.NombreProducto,
          Description: f.Description,
          IdTipo: f.IdTipo,
          NombreTipo: f.NombreTipo,
          IdCurrency: f.IdCurrency,
          CurrencySymbol: f.CurrencySymbol,
          IdUnit: f.IdUnit,
          UnitSimbol: f.UnitSimbol,
          IdCategory: f.IdComponentCategory,
          NombreCategoria: f.NombreCategoria,
          QtyOrdered: f.Quantity,
          UnitPrice: f.Price,
          SubTotal: f.SubTotal,
          Descuento: f.Descuento,
          ISV: f.ISV,
          Total: f.Total,
          IdSubCategory: f.IdSubcategory
        });
      });

      let nuevoArreglo = [...detalleOrdenCompra, ...dataNueva];

      // const isAnyOrderCanceled = detalleOrdenCompra.some(
      //   (detalle) => detalle.IdStatus === 15
      // );

      // if (detalleOrdenCompra.length > 0) {
      //   const monedasDiferentes = nuevoArreglo.some((nuevo) =>
      //     detalleOrdenCompra.some((detalle) => detalle.IdCurrency !== nuevo.IdCurrency)
      //   );

      //   const proveedoresDiferentes = nuevoArreglo.some((nuevo) =>
      //     detalleOrdenCompra.some((detalle) => detalle.IdVendor !== nuevo.IdVendor)
      //   );

      // if (!isAnyOrderCanceled) {
      //   if (monedasDiferentes) {
      //     toastShow(toast, "warn", "Error", "No se puede agregar requisas con monedas diferentes");
      //     return;
      //   }
      //   if (proveedoresDiferentes) {
      //     toastShow(toast, "warn", "Error", "No se puede agregar requisas con proveedores diferentes");
      //     return;
      //   }
      // }

      setDetalleOrdenCompra(nuevoArreglo);
      // } else {
      // setDetalleOrdenCompra(nuevoArreglo);
      // }
    }
  };

  const addNewRow = () => {
    if (verificarCamposEncabezado() === false) {
      if (
        detalleOrdenCompra[detalleOrdenCompra.length - 1]?.IdComponent !== null
      ) {
        let IdDet = -(detalleOrdenCompra?.length + 1);
        const detalles = [
          ...detalleOrdenCompra,
          {
            FechaCreado: new Date(),
            Estado: "En OC",
            IdStatus: 3333,
            IdComponent: null,
            IdPurchaseOrderDetail: IdDet,
            PurchaseRequest: "",
            NombreProducto: "",
            Description: "",
            IdTipo: null,
            NombreTipo: "",
            IdProveedor: null,
            CurrencySymbol: "",
            IdUnit: null,
            UnitSimbol: "",
            IdRequest: null,
            IdCategory: null,
            NombreCategoria: "",
            IdSalesOrder: null,
            SalesOrder: "",
            IdSubCategory: null,
            KgsPR: 0,
            QtyOrdered: 0,
            QtyCalculated: 0,
            QtyReceive: 0,
            UnitPrice: 0,
            Subtotal: 0,
            Descuento: 0,
            ISV: 0,
            Total: 0,
          },
        ];
        setDetalleOrdenCompra(detalles);
      } else {
        toastShow(toast, "warn", "Error", "Se debe de seleccionar un item.");
      }
    }
  };

  const guardarEncabezado = async () => {
    let guardar = true;
    if (verificarCamposEncabezado() === false) {
      if (detalleOrdenCompra.length === 0) {
        toastShow(
          toast,
          "error",
          "Error al guardar",
          "Es necesario agregar al menos un detalle de orden."
        );
        guardar = false;
      }
      // setLoading(true);

      if (guardar) {
        setLoading(true);
        const bodyEncabezado = {
          IdPurchaseOrder: values?.IdPurchaseOrder,
          PurchaseOrder: values.NumeroOrden,
          IdCustomer: values.Cliente.IdCustomer,
          IdVendor: values.Proveedor.IdCustomer,
          IdTerms: values.Terminos.IdTerm,
          IdCurrency: values.Moneda.IdCurrency,
          IdStatus: values.Estado.IdStatus,
          OrderDate: getDateTimeStringSQL(values.Date),
          RequiredDate: getDateTimeStringSQL(values.RequiredDate),
          IdWarehouse: values.Bodega.IdWarehouse,
          IdPurchasePerson: values.Agente.IdAgent,
          Description: values.Comment,
          IdPurchaseType: values.TipoCompra.IdPurchaseType,
          IdShipto: values.ClienteDetalle.IdDCustomer,
          RequiredDateH: getDateTimeStringSQL(values.RequiredDateH),
          SubTotal: values.SubTotal,
          Discount: values.Descuento,
          Tax: values.ISV,
          Freights: values.Freights,
          Otros: values.Otros,
          Total: values.Total,
          Nueva: 1,
          TipoDescuento: 1,
          CalculoDescuento: 0,
          IdArea: values.Area.IdArea,
          OC: values.OC,
          IdPaymentTerms: values.TerminosPago.IdTerm,
          IsPro: values.Pro
        };

        const detalleOrden = detalleOrdenCompra.map((detalle) => ({
          ...detalle[0],
          IdPurchaseOrder: values.IdPurchaseOrder,
          IdComponent: detalle.IdComponent,
          QtyOrdered: detalle.QtyOrdered,
          QtyCalculated: detalle.QtyCalculated,
          QtyReceive: detalle.QtyReceive,
          UnitPrice: detalle.UnitPrice,
          Subtotal: detalle.QtyOrdered * detalle.UnitPrice,
          Description: detalle.Description,
          IdUnit: detalle.IdUnit,
          IdStatus: detalle.IdStatus,
          IdRequest: detalle.IdRequest,
          Descuento: detalle.Descuento,
          IdCategory: detalle.IdCategory,
          IdSubCategory: detalle.IdSubCategory,
          IdTipo: detalle.IdTipo,
          Total:
            detalle.QtyOrdered * detalle.UnitPrice +
            detalle.ISV -
            detalle.Descuento,
          FechaCreado: detalle.FechaCreado,
          ISV: detalle.ISV,
          IdSalesOrder: detalle.IdSalesOrder,
        }));

        if (detalleOrden[0]?.IdPurchaseOrder > 1) {
          const respuestaDetalles = await EditarOrden(
            bodyEncabezado,
            detalleOrden
          );

          if (respuestaDetalles !== -1) {
            setHabilitar(false);
            toastShow(
              toast,
              "success",
              "Guardado",
              respuestaDetalles[0].MENSAJE
            );
            getInfo();
            setLoading(false);
          } else {
            toastShow(
              toast,
              "error",
              "Error al guardar",
              "Error al guardar detalles de la Orden."
            );
            setLoading(false);
          }
        } else {
          const respuestaDetalles = await GuardarOrden(
            bodyEncabezado,
            detalleOrden
          );

          if (respuestaDetalles !== -1) {
            setHabilitar(false);
            toastShow(
              toast,
              "success",
              "Guardado",
              respuestaDetalles[0].MENSAJE
            );
            getInfo();
            setLoading(false);
          } else {
            toastShow(
              toast,
              "error",
              "Error al guardar",
              "Error al guardar detalles de la Orden."
            );
            setLoading(false);
          }
        }
      }
    }
  };

  const setDetalle = (detalle, IdPurchaseOrderDetail = null) => {
    let idOrderDetail = 0;
    if (IdPurchaseOrderDetail) {
      idOrderDetail = IdPurchaseOrderDetail;
    } else {
      idOrderDetail =
        -1 * parseInt((+new Date().getTime() + "").substring(9, 14)) +
        contador++;
    }
    if (
      !detalleOrdenCompra.some(
        (de) => detalle.IdPurcharesRequestDetail === de.IdPurcharesRequestDetail
      )
    ) {
      // handleInputChange({ target: { name: 'Total', value:  } }):
      return {
        FechaCreado: detalle.DateCreated,
        Estado: "En OC",
        IdStatus: 3333,
        IdComponent: detalle.IdProduct,
        IdPurchaseOrderDetail: idOrderDetail,
        PurchaseRequest: detalle.PurchaseRequest,
        IdPurchaseRequest: detalle.IdPurchaseRequest,
        NombreProducto: detalle.NombreProducto,
        Description: detalle.Description,
        IdTipo: detalle.IdTipo,
        NombreTipo: detalle.NombreTipo,
        CurrencySymbol: detalle.CurrencySymbol,
        IdUnit: detalle.IdUnit,
        UnitSimbol: detalle.UnitSimbol,
        IdRequest: detalle.IdPurcharesRequestDetail,
        IdCategory: detalle.IdComponentCategory,
        NombreCategoria: detalle.NombreCategoria,
        IdSalesOrder: detalle.IdSalesOrder,
        SalesOrder: detalle.SalesOrder,
        IdSubCategory: detalle.IdSubcategory,
        KgsPR: null,
        QtyOrdered: detalle.Quantity,
        QtyCalculated: null,
        QtyReceive: null,
        UnitPrice: detalle.Price,
        Subtotal: detalle.Quantity * detalle.Price,
        Descuento: detalle.Descuento,
        ISV: detalle.ISV !== null ? detalle.ISV : 0,
        Total:
          detalle.Quantity * detalle.Price + detalle.ISV - detalle.Descuento,
      };
    }
  };

  const changeEstadoDetalle = () => {
    let tempo = [...detalleOrdenCompra];
    let canDelete = true; // Variable para verificar si se puede eliminar el detalle

    selected.forEach((select) => {
      // Verificar si el detalle tiene IdStatus 3685 (En bodega)
      if (select.IdStatus === 3685 || select.IdStatus === 3331) {
        canDelete = false;
        toastShow(
          toast,
          "warn",
          "Error al eliminar",
          "No se puede eliminar el detalle porque existe un ingreso."
        );
      } else {
        const index = tempo.findIndex(
          (detail) =>
            detail.IdPurchaseOrderDetail === select.IdPurchaseOrderDetail
        );
        if (index >= 0) {
          tempo.splice(index, 1); // Elimina el elemento del arreglo
        }
      }
    });

    if (canDelete) {
      setDetalleOrdenCompra(tempo); // Actualiza el estado con el nuevo arreglo sin el elemento eliminado

      selected.forEach((select) => {
        cambiarEstadoOrdenDetalle(select);
      });
      toastShow(
        toast,
        "success",
        "Eliminado",
        "Detalle de orden de compra eliminado."
      );
      getInfo();
    }
  };

  const eliminarItemDetalle = (position) => {
    if (selected.length > 0) {
      confirmDialog({
        message: "Esta seguro que desea eliminar este item",
        header: "Cancelar",
        icon: "pi pi-exclamation-triangle",
        acceptLabel: "Si",
        accept: () => changeEstadoDetalle(),
        rejectLabel: "No",
        style: { backgroundColor: "white" },
      });
    } else {
      toastShow(
        toast,
        "warn",
        "Advertencia",
        "Seleccione al menos un detalle."
      );
      // confirmDialog({
      //   message: "Debe seleccionar un detalle",
      //   header: "Cancelar",
      //   icon: "pi pi-exclamation-triangle",
      //   acceptLabel: "OK",
      //   rejectLabel: " ",
      //   className: "dialog_detalle",
      //   style: { backgroundColor: "white" },
      // });
    }
  };

  const habilitarComponentes = () => {
    setHabilitar(true);
  };

  const nuevaRequisa = () => {
    confirmDialog({
      message: "Esta seguro que desea crear una nueva orden de compra",
      header: "Cancelar",
      icon: "pi pi-exclamation-triangle",
      acceptLabel: "Si",
      accept: () => obtenerInfoInput(true),
      rejectLabel: "No",
      style: { backgroundColor: "white" },
    });
  };

  const agregarDetalleRequisa = async (PurchaseRequest) => {
    if (verificarCamposEncabezado() === false) {
      let tempo = [];
      if (PurchaseRequest?.IdPurchaseRequest) {
        const detalles = await getPurchaseRequestDetailAuth(
          PurchaseRequest?.IdPurchaseRequest
        );
        if (values.Pro) {
          if (values.Proveedor !== null) {
            detalles.forEach((detalle) => {
              if (!verificarExiste(detalle)) {
                if (detalle.IdProveedor === values.Proveedor?.IdCustomer) {
                  const newDetalle = setDetalle(detalle);
                  tempo.push(newDetalle);
                }
              }
            });
          } else {
            toastShow(toast, "warn", "Error", "Seleccione un Proveedor");
          }
        } else {
          detalles.forEach((detalle) => {
            if (!verificarExiste(detalle)) {
              const newDetalle = setDetalle(detalle);
              tempo.push(newDetalle);
            }
          });
        }

        setDetalleOrdenCompra([...detalleOrdenCompra, ...tempo]);
      } else {
        toastShow(toast, "warn", "Error", "Seleccione una requisa.");
      }
    }
  };

  const Functions = {
    addNewRow,
    guardarEncabezado,
    habilitarComponentes,
    eliminarItemDetalle,
    nuevaRequisa,
    getInfo,
    agregarDetalleRequisa,
    addRequisas,
    verificarCamposEncabezado
  };

  const verificarExiste = (detalleToInsert) => {
    const existe = detalleOrdenCompra.some(
      (detalle) =>
        detalle.IdRequest === detalleToInsert.IdPurcharesRequestDetail
    );
    if (existe) {
      toastShow(toast, "warn", "Item ya esta agregado", "");
    }
    return existe;
  };

  const selectedItemChange = ({ data, api }, IdPurchaseOrderDetail) => {
    if (!verificarExiste(data)) {
      const index = detalleOrdenCompra.findIndex(
        (detail) => detail.IdPurchaseOrderDetail === IdPurchaseOrderDetail
      );
      let tempo = [...detalleOrdenCompra];
      tempo[index] = setDetalle(data, IdPurchaseOrderDetail);
      setDetalleOrdenCompra(tempo);
      overlayItemRef.current.hide();
      api.stopEditing();
    } else {
    }
  };

  const obtenerDetalleCustomer = async () => {
    let customersDetaill;
    if (values.Cliente?.IdCustomer) {
      customersDetaill = await getCustomersDetail(values.Cliente?.IdCustomer);
    } else {
      customersDetaill = [];
    }
    setinputValues({
      ...inputValues,
      ClientesDetalle: customersDetaill,
    });
  };

  const columns = [
    {
      field: 'IdPurchaseOrderDetail',
      header: 'ID',
      className: "Xsmall",
      alignFrozen: "left",
      frozen: "frozen",
      hidden: userAuth.IdRol === 1,
    },
    {
      // NUMERO REQUISA
      field: "PurchaseRequest",
      header: "No. Requisa",
      className: "medium",
      frozen: "frozen",
    },
    {
      // FECHA CREADO
      field: "FechaCreado",
      header: "Fecha Creado",
      className: "large",
      Format: "Date",
    },
    {
      // ESTADO
      field: "Estado",
      header: "Estado",
      className: "medium",
      body: (rowData) => {
        return { ID: rowData.IdStatus, Estado: rowData.Estado };
      },
      Format: "Estado",
    },
    {
      // ITEM
      field: "IdComponent",
      header: "Item",
      editable: habilitar,
      cellEditor: ({ data }) => (
        <ItemOverlayPanel
          IdPurchaseOrderDetail={data.IdPurchaseOrderDetail}
          selectedItemChange={selectedItemChange}
          overlayItemRef={overlayItemRef}
          detalleOrdenCompra={detalleOrdenCompra}
          IdComponent={data.IdComponent}
          IdMoneda={values.Moneda?.IdCurrency}
          IdProveedor={values.Proveedor?.IdCustomer}
          IsPro={values.Pro}
        />
      ),
      className: "medium",
      Sumary: "count",
    },
    {
      // ORDEN VENTAS
      field: "SalesOrder",
      header: "Orden Ventas",
      className: "medium",
    },
    {
      // PRODUCTO
      field: "NombreProducto",
      header: "Producto",
      className: "XXXlarge",
    },
    {
      // DESCRIPCION PRODUCTO
      field: "Description",
      header: "Descripcion",
      className: "XXXlarge",
    },
    {
      // TIPO PRODUCTO
      field: "NombreTipo",
      header: "NombreTipo",
      className: "large",
    },
    {
      // MONEDA
      field: "CurrencySymbol",
      header: "Moneda",
      className: "small",
    },
    {
      // TIPO COMPRA
      field: "TipoCompra",
      header: "Tipo",
      className: "medium",
    },
    {
      // UNIDAD
      field: "UnitSimbol",
      header: "Unidad",
      className: "Xsmall",
    },
    {
      // CATEGORIA
      field: "NombreCategoria",
      header: "Categoria",
      className: "medium",
    },
    {
      // KGS
      field: "KgsPR",
      header: "Kgs",
      className: "small",
    },
    {
      // CANTIDAD ORDENADO
      field: "QtyOrdered",
      header: "Ordenado",
      className: "small",
      Format: "Currency",
      // editor: habilitar === false ? ({ rowData }) => inputNumberTemplate(rowData.QtyOrdered, changeValueInput, { rowData: rowData, valueToChange: 'QtyOrdered' }) : null,
      frozen: "frozen",
      alignFrozen: "right",
    },
    {
      // PRECIO
      field: "UnitPrice",
      header: "Precio",
      className: "small",
      Format: "Currency",
      // editor: habilitar === false ? ({ rowData }) => inputNumberTemplate(rowData.UnitPrice, changeValueInput, { rowData: rowData, valueToChange: 'UnitPrice' }) : null,
      frozen: "frozen",
      alignFrozen: "right",
      hidden: !accesoColumnas,
    },
    {
      // SUBTOTAL
      field: "SubTotal",
      header: "SubTotal",
      className: "small",
      frozen: "frozen",
      alignFrozen: "right",
      Format: "Currency",
      hidden: !accesoColumnas,
    },
    {
      // DESCUENTO
      field: "Descuento",
      header: "Descuento",
      className: "small",
      Format: "Currency",
      // editor: habilitar === false ? ({ rowData }) => inputNumberTemplate(rowData.Descuento, changeValueInput, { rowData: rowData, valueToChange: 'Descuento' }) : null,
      frozen: "frozen",
      alignFrozen: "right",
      hidden: !accesoColumnas,
    },
    {
      // ISV
      field: "ISV",
      header: "ISV",
      className: "small",
      Format: "Currency",
      // editor: habilitar === false ? ({ rowData }) => inputNumberTemplate(rowData.ISV, changeValueInput, { rowData: rowData, valueToChange: 'ISV' }) : null,
      sortable: true,
      frozen: "frozen",
      alignFrozen: "right",
      hidden: !accesoColumnas,
    },
    {
      // TOTAL
      field: "Total",
      header: "Total",
      className: "small",
      Format: "Currency",
      // body: (rowData) => decimalTemplate((rowData.QtyOrdered * rowData.UnitPrice) + rowData.ISV - rowData.Descuento),
      frozen: "frozen",
      alignFrozen: "right",
      hidden: !accesoColumnas,
      Sumary: 'sum'
    },
  ];

  const table = {
    Columns: columns,
    Data: detalleOrdenCompra,
    // loading: loading,
    selected: selected,
    setSelected: setSelected,
    ref: dtAutorizarRequisa,
  };

  useEffect(() => {
    obtenerInfoInput();
  }, [PurchaseOrder]);

  useEffect(() => {
    resetTable(detalleOrdenCompra);
  }, [detalleOrdenCompra]);

  useEffect(() => {
    obtenerDetalleCustomer();
  }, [values.Cliente]);

  return (
    <div>
      <Toast ref={toast} />
      {/* <ConfirmDialog /> */}
      <Loader loading={loading} />
      <EncabezadoOrdenesCompras
        values={values}
        handleInputChange={handleInputChange}
        habilitar={habilitar}
        clienteDetalles={clienteDetalles}
        setNumber={setNumber}
        Functions={Functions}
        inputValues={inputValues}
      />
      <div className="mt-2" style={{ height: "65vh" }}>
        <AgGrid table={table} />
      </div>
    </div>
  );
};

export default OrdenesComprasCrud;
